import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ArrowRightThin } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useCallback } from 'react';
import { isCurrentLocation } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SubList = styled('ul', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isOpen';
  }
})(function (_ref) {
  var theme = _ref.theme,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;
  return _objectSpread({
    maxHeight: 0,
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'cubic-bezier(0, 1, 0.5, 1)',
    background: theme.palette.background.paper,
    listStyle: 'none'
  }, isOpen && {
    maxHeight: theme.spacing(500),
    transitionDuration: '0.4s',
    transitionTimingFunction: 'ease-in'
  });
});
var CustomLinkItem = styled('a', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'hasIcon' && prop !== 'isActive';
  }
})(function (_ref2) {
  var theme = _ref2.theme,
    _ref2$hasIcon = _ref2.hasIcon,
    hasIcon = _ref2$hasIcon === void 0 ? false : _ref2$hasIcon,
    _ref2$isActive = _ref2.isActive,
    isActive = _ref2$isActive === void 0 ? false : _ref2$isActive;
  return _objectSpread({
    display: 'block',
    position: 'relative',
    boxSizing: 'border-box',
    padding: theme.spacing(2, 3, 2, 0),
    overflow: 'hidden',
    color: theme.palette.grey[700],
    backgroundColor: 'transparent',
    fontSize: '15px',
    letterSpacing: '0.5px',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    userSelect: 'none'
  }, hasIcon ? _objectSpread({
    lineHeight: theme.spacing(6),
    paddingLeft: theme.spacing(10),
    fontWeight: 'bold',
    ':before': {
      position: 'absolute',
      top: '50%',
      left: theme.spacing(3),
      transform: 'translateY(-50%)',
      fontSize: '28px'
    },
    '&:hover': {
      color: theme.palette.grey[700],
      backgroundColor: theme.palette.grey[100]
    }
  }, isActive && {
    backgroundColor: theme.palette.grey[100]
  }) : _objectSpread({
    lineHeight: theme.spacing(4),
    '&:hover': {
      color: theme.palette.grey[400]
    }
  }, isActive && {
    fontWeight: 'bold'
  }));
});
var CustomButton = styled('button', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isOpen' && prop !== 'isClicked' && prop !== 'hasIcon';
  }
})(function (_ref3) {
  var theme = _ref3.theme,
    _ref3$hasIcon = _ref3.hasIcon,
    hasIcon = _ref3$hasIcon === void 0 ? false : _ref3$hasIcon,
    _ref3$isOpen = _ref3.isOpen,
    isOpen = _ref3$isOpen === void 0 ? false : _ref3$isOpen,
    _ref3$isClicked = _ref3.isClicked,
    isClicked = _ref3$isClicked === void 0 ? false : _ref3$isClicked;
  return _objectSpread(_objectSpread(_objectSpread({
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: theme.spacing(0, 2, 0, 0),
    color: theme.palette.grey[700],
    backgroundColor: 'transparent',
    fontSize: '15px',
    letterSpacing: '0.5px',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    userSelect: 'none'
  }, hasIcon ? {
    paddingLeft: theme.spacing(10),
    fontWeight: 'bold',
    ':before': {
      position: 'absolute',
      top: '50%',
      left: theme.spacing(3),
      transform: 'translateY(-50%)',
      fontSize: '28px'
    },
    ':hover': {
      backgroundColor: theme.palette.grey[100],
      cursor: 'pointer'
    }
  } : {
    '&:hover': {
      color: theme.palette.grey[400]
    }
  }), isOpen && !isClicked && {
    fontWeight: 'bold'
  }), isOpen && !hasIcon && {
    color: theme.palette.grey[700]
  });
});
var Item = styled('li')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    borderBottom: "2px solid ".concat(theme.palette.background.paper),
    listStyle: 'none',
    padding: 0,
    '& ul': {
      '& li': {
        marginLeft: theme.spacing(3)
      }
    }
  };
});
var SubItem = styled(Item)({
  borderBottom: 'initial'
});
var Caret = styled(ArrowRightThin, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isOpen' && prop !== 'isSubmenu';
  }
})(function (_ref5) {
  var _ref5$isOpen = _ref5.isOpen,
    isOpen = _ref5$isOpen === void 0 ? false : _ref5$isOpen,
    _ref5$isSubmenu = _ref5.isSubmenu,
    isSubmenu = _ref5$isSubmenu === void 0 ? false : _ref5$isSubmenu;
  return {
    transition: 'transform ease-in 0.3s',
    transform: "rotate(".concat(isOpen ? 270 : 90, "deg)"),
    fontSize: isSubmenu ? '1.8rem' : '2.4rem'
  };
});
export var AccordionMenuItem = function AccordionMenuItem(_ref6) {
  var menuItem = _ref6.menuItem,
    menuClickedItem = _ref6.menuClickedItem,
    onMenuClick = _ref6.onMenuClick,
    _ref6$isSubmenu = _ref6.isSubmenu,
    isSubmenu = _ref6$isSubmenu === void 0 ? false : _ref6$isSubmenu;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var isMenuItemOpen = useCallback(function (item) {
    if (menuClickedItem.path === item.itemPath) {
      return menuClickedItem.open;
    }
    return menuClickedItem.path.startsWith(item.itemPath);
  }, [menuClickedItem]);
  var renderSubMenu = useCallback(function (item) {
    if (item.subItems.length) {
      var isOpen = isMenuItemOpen(item);
      return /*#__PURE__*/_jsx(SubList, {
        isOpen: isOpen,
        children: item.subItems.map(function (subitem) {
          return /*#__PURE__*/_jsx(AccordionMenuItem, {
            isSubmenu: true,
            menuItem: subitem,
            menuClickedItem: menuClickedItem,
            onMenuClick: onMenuClick
          }, subitem.itemPath);
        })
      });
    }
    return null;
  }, [isMenuItemOpen, menuClickedItem, onMenuClick]);
  var renderLink = useCallback(function (item) {
    var _item$url, _item$icon;
    return /*#__PURE__*/_jsx(CustomLinkItem, {
      href: (_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : '',
      className: (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.toString(),
      hasIcon: Boolean(item.icon),
      isActive: isCurrentLocation(item.url),
      children: item.title
    });
  }, []);
  var renderButton = useCallback(function (item) {
    var _item$icon2;
    var clickParams = {
      path: item.itemPath,
      open: true
    };
    var isOpen = isMenuItemOpen(item);
    if (isOpen) {
      clickParams.open = false;
    }
    return /*#__PURE__*/_jsxs(CustomButton, {
      isOpen: menuClickedItem.open,
      isClicked: clickParams.open,
      hasIcon: Boolean(item.icon),
      className: (_item$icon2 = item.icon) === null || _item$icon2 === void 0 ? void 0 : _item$icon2.toString(),
      onClick: function onClick(event) {
        onMenuClick(event, clickParams);
      },
      children: [item.title, /*#__PURE__*/_jsx(Caret, {
        isOpen: isOpen,
        isSubmenu: isSubmenu
      })]
    });
  }, [isMenuItemOpen, menuClickedItem, onMenuClick, isSubmenu]);
  var itemContent = null;
  var subItems = null;
  var ItemComponent = isSubmenu ? SubItem : Item;
  if (menuItem.subItems.length) {
    itemContent = renderButton(menuItem);
    subItems = renderSubMenu(menuItem);
  } else {
    itemContent = renderLink(menuItem);
  }
  return /*#__PURE__*/_jsxs(ItemComponent, {
    "data-testid": getTestId("accordion-".concat(menuItem.itemPath.replaceAll('/', ''))),
    children: [itemContent, subItems]
  });
};